import { useEffect, useState } from "react";
import { stats } from "../data";
import { Reveal } from "./Primitives";

const CountUp = ({ value }) => {
  const m = String(value).match(/(\d[\d,]*)/);
  const target = m ? parseInt(m[1].replace(/,/g, ""), 10) : null;
  const [n, setN] = useState(target == null ? null : 0);

  useEffect(() => {
    if (target == null) return;
    let raf;
    const dur = 1500;
    const start = performance.now();
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * target));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target]);

  if (target == null) return value;
  return String(value).replace(m[1], n.toLocaleString());
};

export const Stats = () => {
  return (
    <section id="stats" className="border-y border-black/5 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-y lg:divide-y-0 divide-black/5">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className="px-6 py-12 sm:py-16 flex flex-col gap-2" data-testid={`stat-${i}`}>
                <span className="font-display text-4xl sm:text-5xl font-medium tracking-tight aes-gradient-text tabular-nums">
                  <CountUp value={s.value} />
                </span>
                <span className="text-sm font-medium text-[#0A0A0A] mt-1">{s.label}</span>
                {s.note && <span className="text-xs text-[#A1A1AA] leading-relaxed">{s.note}</span>}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
